import request from '@/utils/request'

/**
 * 查询店铺短信详情列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listAShopSmsDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.listAShopSmsDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listAShopSms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopSms.listAShopSms',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}